<template>
    <tr class="create-invoice-line vertical-align-top">
        <td class="col-cmd">
            <Checkbox :model='model' v-model='item.checked'></Checkbox>            
        </td>
        <td class="draghandle col-cmd">
            <span>
                <Icon class="cursor-move-y" type="drag"></Icon>
            </span>
        </td>
        <td class="">
            <NumberField max="1000000" decimal dusk="amount" no-border :model='model' :rules='model.mandatory' v-model='item.ihp_amount' ></NumberField>
        </td>
        <td class="">
            <UnitCombo dusk="unit" no-border :model='model' v-model='item.id_unity'></UnitCombo>
        </td>
        <td colspan="2" class="">
            <RichTextLine class="w-min-none" dusk="name" no-border ref="rfocus" :model="model" placeholder="Omschrijving" v-model="item.ihp_pd_name"></RichTextLine>
        </td>
        <td class="">
            <NumberField max="20000000" dusk="price" no-border amount :model='model' :rules='model.mandatory' v-model='item.ihp_purchase_price' :currency='item.crnc_code'></NumberField>
        </td>
        <td class="">
            <NumberField max="20000000" dusk="price" no-border amount :model='model' :rules='model.mandatory' v-model='item.ihp_sales_price' :currency='item.crnc_code'></NumberField>
        </td>
        <td class="text-right pr-3 pt-2">
            <NoMarginCalculationHint v-if="!item.canCalculateMargin" title="Marge kan niet worden berekend">
                <p>De marge kan niet worden berekend omdat er geen kostprijs of geen stukprijs is ingevuld.</p>
                <p>Vul het tarief in bij de medewerker of vul de prijzen in deze regel.</p>
            </NoMarginCalculationHint>
            <PercentageText v-else :class="{'text-success': item.marginPct > 0, 'text-error': item.marginPct <= 0}" decimals="0" no-border v-model='item.marginPct'/>    
        </td>
        <td class="">
            <VatCombo dusk="vat"  no-clearable standard-types no-border :model='model' :rules='model.mandatory' v-model='item.id_vat'></VatCombo>
        </td>
        <td class="text-right pr-3 pt-2">
            <AmountText dusk="totalpricesales" no-border v-model='item.total_amount_sales'/>    
        </td>
    </tr>
</template>

<script setup>

    import { computed, ref } from 'vue'
    import ActionButton from '@shared/ui/controls/buttons/ActionButton'
    import NumberField from '@controls/input/NumberField'
    import VatCombo from '@controls/combo/Vat'
    import Icon from '@controls/icons/Icon'
    import UnitCombo from '@controls/combo/Unit'    
    import ProductPicker from '@controls/picker/Product'
    import AmountText from '@controls/text/Amount.vue' 
    import PercentageText from '@controls/text/Percentage.vue' 
    import RichTextLine from '@controls/input/RichTextLine'
    import Checkbox from '@controls/check/Checkbox.vue'
    import NoMarginCalculationHint from './NoMarginCalculationHint.vue'
    const props = defineProps({
        model: {
            type: [Object]
        },
        item: {
            type: [Object]
        }, 
        columnHeaders: {
            type: [Object, Array]
        },        
    });

    async function removeLine(item) {
        props.model.removeLine(item)
    }


</script>